import { AddIcon, Button, ListDetailLayout } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../layout/FullPageLayout/FullPageLayout';
import CreateUpdateTopicModal from '../components/CreateUpdateTopicModal/CreateUpdateTopicModal';
import NewSubTopicModal from '../components/NewSubTopicModal/NewSubTopicModal';
import SubTopicListPanel from '../components/SubTopicListPanel/SubTopicListPanel';
import TopicListPanel from '../components/TopicListPanel/TopicListPanel';
import { useTopicListPage } from './useTopicListPage';

export default function TopicListPage() {
  const page = useTopicListPage();

  return (
    <>
      <FullPageLayout
        htmlTitle="Sujets"
        title="Sujets"
        action={page.isAdmin ? (
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            onClick={page.handleOpenNewTopicModal}
          >
            Nouveau sujet
          </Button>
        ) : undefined}
        fixedHeader
      >
        <ListDetailLayout
          showDetail={Boolean(page.topicId)}
          list={<TopicListPanel page={page} />}
          detail={<SubTopicListPanel page={page} />}
        />
      </FullPageLayout>

      {page.isNewTopicModalOpen ? (
        <CreateUpdateTopicModal
          onClose={page.handleCloseNewTopicModal}
          onCreated={page.handleTopicCreated}
        />
      ) : null}

      {page.isNewSubTopicModalOpen && page.topicId ? (
        <NewSubTopicModal
          topicId={page.topicId}
          onClose={page.handleCloseNewSubTopicModal}
          onSuccess={page.handleSubTopicCreated}
        />
      ) : null}
    </>
  );
}
